import { render, staticRenderFns } from "./VCardDialog.vue?vue&type=template&id=2ea9abb5&scoped=true"
import script from "./VCardDialog.vue?vue&type=script&lang=ts"
export * from "./VCardDialog.vue?vue&type=script&lang=ts"
import style0 from "./VCardDialog.vue?vue&type=style&index=0&id=2ea9abb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9abb5",
  null
  
)

export default component.exports